import { StyledTabFilters } from "./styled"
import { ITabFiltersProps } from "./types";
import { FilterButton } from "../FilterButton";

const TabFilters = ({ filters, selectedFilter, onFilterChange }: ITabFiltersProps) => {
    return (
        <StyledTabFilters>
            {filters.map((filter) => (
                <FilterButton
                    key={filter.id}
                    label={filter.label}
                    onClick={() => onFilterChange(filter)}
                    isSelected={selectedFilter.id === filter.id}
                />
            ))}
        </StyledTabFilters>
    )
}

export { TabFilters };